<div class="row filter-collapse" #filterCollapse>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-12 col-md-4 col-lg-3">
                <label for="numeroErp" class="col-form-label">Número</label>
                <input type="text" class="form-control" [(ngModel)]="filter.numeroErp" name="numeroErp" id="numeroErp"
                    (ngModelChange)="isFilterDirty = true;">
            </div>             
            <div class="form-group col-12 col-md-4 col-lg-3">
                <label for="situacao" class="col-form-label">Situação</label>
                <select class="form-control" name="situacao" id="situacao" 
                    [ngModel]="filter.situacao || ''" (ngModelChange)="filter.situacao = $event ? $event : null; isFilterDirty = true">
                    <option value="">Selecione a situação...</option>
                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                </select>          
            </div>                       
        </div>
        <div class="row">
            <div class="form-group col-12" [class.col-md-6]="!isRepresentante">
                <label for="pessoa" class="col-form-label">Cliente</label>
                <sgt-typeahead-cliente-pessoa [(ngModel)]="filter.pessoa" name="pessoa" id="pessoa"
                    #pessoa="ngModel" [ngControl]="pessoa" 
                    (typeaheadChange)="onTypeaheadChangeCliente($event)">
                </sgt-typeahead-cliente-pessoa>                                  
            </div>
            <div class="form-group col-12 col-md-6" *ngIf="!isRepresentante">
                <label for="representante" class="col-form-label">Representante</label>
                <sgt-typeahead-representante [(ngModel)]="filter.representante" name="representante" id="representante"
                    #representante="ngModel" [ngControl]="representante"
                    (typeaheadChange)="onTypeaheadChangeRepresentante($event)">
                </sgt-typeahead-representante>                                                                  
            </div>                       
        </div>
        <div class="row"  *ngIf="configEmpresa?.possuiLocalFaturamento">
            <div class="form-group col-12">
                <label class="col-form-label">Locais de Faturamentos</label>
                <sgt-local-faturamento-multiselect
                    [(idsLocaisFaturamentos)]="filter.idsLocaisFaturamentos"
                    (idsLocaisFaturamentosChange)="onChangeLocaisFaturamentos()"
                    [dropup]="true">
                </sgt-local-faturamento-multiselect> 
            </div>             
        </div>
    </div>
</div>